import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5m0iqm5t: FaireBrandEntity = {
  token: "b_5m0iqm5t",
  type: "brand",
  name: "Egg Press Manufacturing",
  avatarUrl:
    "https://cdn.faire.com/fastly/50ed26cec3f5a6fc941c5420404a5dae392499f979066794a7a4815f0805c3f1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/abc8c6a9f9e5ceabae570e5f0c59a2854af142f7b2c49c54bb9338268a7c9a4a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/50ed26cec3f5a6fc941c5420404a5dae392499f979066794a7a4815f0805c3f1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/abc8c6a9f9e5ceabae570e5f0c59a2854af142f7b2c49c54bb9338268a7c9a4a.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 176,
  isTopShop: true,
  isInsider: true,
  description:
    "EP MFG is a collective of nice people. We print and distribute letterpress cards for a variety of independent design brands. Our mission is to make people feel good, and encourage them to make others feel good too.\n\nWe like to think of ourselves as ‘thoughtful as hell’ -- with a commitment to craft, sustainable manufacturing, and putting people first in all that we do.\n \nHere’s what you get when you work with us:\n\nReally Good Letterpress:\nWe do letterpress the traditional way: by hand, with artistry and attention to craftsmanship. Every card we manufacture is exceptionally made. \n\nHigh Volume:\nWith well over half a million cards going out the door each year, we offer quality and quantity at a speed not typically associated with the “snail mail” we produce.\n\nSustainable Manufacturing:\nWe make responsibly. From what we use, to how we use it, and constantly looking for ways to use less. We piloted our plastic-free packaging in 2023 with great success, eliminating plastic sleeves on 66% of cards that go out the door! ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:00.389Z",
    importedBy: "entity-db-cli",
  },
};
